<template>
    <div>
        <b-tabs
            vertical
            nav-wrapper-class="nav-vertical"
        >
            <b-tab
            active
            >
                <template #title>
                    Portfolio <span class="text-danger ml-1">*</span>
                </template>
                <form-category :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements"  ref="formCategory"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Description <span class="text-danger ml-1">*</span>
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Short Description <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col sm="12">
                        <validation-provider
                        #default="{ errors }"
                        name="Short Description"
                        rules="required"
                        >
                        <snote v-model="content.shortDescription" ref="snoteSDescription"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div>Description <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col sm="12">
                        <validation-provider
                        #default="{ errors }"
                        name="Description"
                        rules="required"
                        >
                        <snote v-model="content.description" ref="snoteDescription"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Benefit <span class="text-danger ml-1">*</span>
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Benefit <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Benefit"
                        rules="required"
                        >
                        <snote v-model="content.benefit" ref="snoteBenefit"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Value Proposition
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Value Proposition</div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Value Proposition"
                        >
                        <snote v-model="content.valueProposition" ref="snoteProposition"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Sales Proposition
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Sales Proposition</div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Sales Proposition"
                        >
                        <snote v-model="content.salesProposition" ref="snoteSalesProposition"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Customer STP <span class="text-danger ml-1">*</span>
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Customer STP <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Customer STP"
                        rules="required"
                        >
                        <snote v-model="content.customerSTP" ref="snoteSTP"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Specification/Features
                </template>
                <b-container>
                    <b-col sm="12">
                        <div>Specification/Features</div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Specification/Features"
                        >
                        <snote v-model="content.spesificationFeatures" ref="snoteSpesificationFeatures"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Related Product
                </template>
                <form-related-product :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formRelatedProduct"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Configuration <span class="text-danger ml-1">*</span>
                </template>
            <b-container>
                    <b-col sm="12">
                        <div>Configuration <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="Configuration"
                        rules="required"
                        >
                        <snote v-model="content.configuration" ref="snoteConfiguration"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container> 
            </b-tab>
            <b-tab
            v-if="isAdmin"
            >
                <template #title>
                    Tarif
                </template>
                <form-tarif :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formTarif"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Case Study
                </template>
                <form-case-study :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formCaseStudy"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Testimonial
                </template>
                <form-testimonial :product-kode="productKode" ref="formTestimonial"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    SLG/SLA <span class="text-danger ml-1">*</span>
                </template>
            <b-container>
                    <b-col sm="12">
                        <div>SLG/SLA <span class="text-danger">*</span></div> 
                    </b-col>
                    <b-col>
                        <validation-provider
                        #default="{ errors }"
                        name="SLG/SLA"
                        rules="required"
                        >
                        <snote v-model="content.slgsla" ref="snoteSlgsla"/>
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        </validation-provider>
                    </b-col>
                </b-container>  
            </b-tab>
            <b-tab
            >
                <template #title>
                    Contact
                </template>
                <b-container>
                    <b-row>
                        <b-col sm="12">
                            <form-contact :content="content" :options="options"/>
                        </b-col>
                    </b-row>
                </b-container>
            </b-tab>
            <b-tab
            >
                <template #title>
                    FAQ <span class="text-danger ml-1">*</span>
                </template>
                <form-faq :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formFAQ"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Video Product & Sharing Session
                </template>
                <form-product-sharing :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formProductSharing"/>
            </b-tab>
            <b-tab
            >
                <template #title>
                    Product Reference <span class="text-danger ml-1">*</span>
                </template>
                <form-referensi-product :content="content" :options="options" :methods="methods" :dropzoneElements="dropzoneElements" ref="formReferensiProduct"/>
                
            </b-tab>
        </b-tabs>
        <b-modal
        id="modal-login"
        cancel-variant="outline-secondary"
        ok-title="Ok"
        cancel-title="Close"
        centered
        title="Name"
        ref="nameModal"
        @ok="setCurrentFile"
        >
        <b-form>
            <b-form-group>
            <label for="name">Name:</label>
            <b-form-input
                id="name"
                placeholder="Name File"
                v-model="currentFileName"
            />
            </b-form-group>
        </b-form>
        </b-modal>
        
    </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { BModal } from 'bootstrap-vue'
import { BLink, BImg, BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BOverlay, BBadge } from 'bootstrap-vue'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import Product from './product.vue'
import Ripple from 'vue-ripple-directive'
import FormContact from './formContact.vue'
import FormCategory from './formCategory.vue'
import FormProductSharing from './formProductSharing.vue'
import FormReferensiProduct from './formReferensiProduct.vue'
import FormTarif from './formTarif.vue'
import FormCaseStudy from './formCaseStudy.vue'
import FormRelatedProduct from './formRelatedProduct.vue'
import FormFAQ from './formFAQ.vue'
import FormTestimonial from './formTestimonial.vue'
import snote from './summernote.vue'

export default {
  components: {
    BCardText,
    BTabs,
    BTab,
    BLink,
    BImg,
    BCol,
    BContainer,
    BRow,
    BCard,
    BProgress,
    BCardText,
    BDropdown,
    BDropdownItem,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BModal,
    BBadge,
    vSelect,
    quillEditor,

    'product-list': Product,
    'form-contact': FormContact,
    'form-category': FormCategory,
    'form-product-sharing': FormProductSharing,
    'form-referensi-product': FormReferensiProduct,
    'form-tarif': FormTarif,
    'form-related-product': FormRelatedProduct,
    'form-faq': FormFAQ,
    'form-case-study': FormCaseStudy,
    'form-testimonial': FormTestimonial,

    'snote': snote
  },
  directives: {
    Ripple,
},
  props: {
      content: Object,
      options: Object,
      methods: Object,
      dropzoneElements: Object,
      productKode: String,
  },
  data() {
      return {
          divisions: [],
          timePortfolios: [],
          currentFile: '',
          currentFileName: '',
          mapCurrentFile: [],
          warningProduct: false,
          tempSelectedUser: null,
      }
  },
  computed: {
      isAdmin() {
            let role = this.$store.getters['oauth/getActiveUser'].role
            if (role.includes('approver') || role.includes('admin')) {
                return true
            }
            return false
        },
  },
  mounted() {
        
  },
  methods: {
    syncMedia() {
        this.$refs.formCategory.syncMedia()
        this.$refs.formProductSharing.syncMedia()
        if (this.$refs.formTarif) {
            this.$refs.formTarif.syncMedia()
        }
        this.$refs.formCaseStudy.syncMedia()
        this.$refs.formReferensiProduct.syncMedia()
    },
    showMsgBoxName() {
        let vm = this
        vm.$refs.nameModal.show()
    },
    setCurrentFile() {
        let file = {
            name: this.currentFileName,
            file: this.currentFile
        }
        this.content[this.mapContainerId] = [...this.content[this.mapContainerId], file]
        this.currentFile = ''
        this.currentFileName = ''
    },
    setTempSelectedRelatedProduct(item) {
        let selected = null
        if (item.length > 0 ) {
            selected = item[0]
        }
        this.tempSelectedRelatedProduct = selected
    },
    setSelectedProduct() {
        this.content.relatedProduct.push(this.tempSelectedRelatedProduct)
        console.log(this.content.relatedProduct)
        this.warningProduct = false
    },
    removeRelatedProductItem(kode) {
        this.content.relatedProduct = this.content.relatedProduct.filter(item => {
            return item.KODE !== kode
        })
    },
    updateEditor() {
        if (this.$refs.formTarif) {
            this.$refs.formTarif.updateEditor()
        }
        this.$refs.snoteDescription.updateEditor()
        this.$refs.snoteSDescription.updateEditor()
        this.$refs.snoteBenefit.updateEditor()
        this.$refs.snoteProposition.updateEditor()
        this.$refs.snoteSalesProposition.updateEditor()
        this.$refs.snoteSTP.updateEditor()
        this.$refs.snoteSpesificationFeatures.updateEditor()
        this.$refs.snoteConfiguration.updateEditor()
        this.$refs.formCaseStudy.updateEditor()
        this.$refs.snoteSlgsla.updateEditor()
        this.$refs.formFAQ.updateEditor()
    }
  }
}
</script>

<style>
.nav-pills .nav-link, .nav-tabs .nav-link {
    justify-content: start !important;
}
</style>

<style scoped>
.dropzone {
    min-height: 250px;
}
.dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
